import React, { useContext } from 'react';
import Context from '../../contexts/MarketPerformanceContext';
import { truncateNumber, urlEncode } from '../../utilities/Utils';
import LastUpdatedIndicator from './LastUpdatedIndicator';
import {VoidState} from "../../utilities/VoidState";
import BackLink from "./Components/BackLink";

const FullIndices = () => {
    const context = useContext(Context);

    if (!context.state.loading && context.state.showError) {
        return (
            <div className="instrument-table">
                <div className="instrument-table-top-container fb-pb-3">
                    <BackLink handleOnclick={context.backToOverview} />
                </div>
                <VoidState message={context.state.error.message} />
            </div>
        );
    }

    return (
        <div className="instrument-table">
            <div className="instrument-table-top-container fb-pb-3">
                <BackLink handleOnclick={context.backToOverview} />
                <div className="d-xl-block d-none">
                    <LastUpdatedIndicator />
                </div>
            </div>
            {(!context.state.fullIndices || !context.state.fullIndices.length != 0) ? <p>Full indices not available.</p> :
                <table className="table mb-0">
                    <thead>
                        <tr>
                            <th className="d-table-cell">
                                Index name
                                <p className="text-grey mb-0 d-block d-xl-none">Code</p>
                            </th>

                            <th className="d-none d-xl-table-cell">Code</th>

                            <th className="text-right d-none d-xl-table-cell">Market Value</th>

                            <th className="text-right d-none d-xl-table-cell">High</th>
                            <th className="text-right d-none d-xl-table-cell">Low</th>

                            <th className="text-right combined-values d-table-cell d-xl-none">
                                <p className="text-nowrap mb-0">Market Value</p>
                                <p className="text-grey text-nowrap mb-0">Change (%)</p>
                            </th>
                            <th className="text-right d-none d-xl-table-cell">Change</th>
                            <th className="change-percentage d-none d-xl-table-cell text-right">%</th>
                            <th className="fb-pl-0 fb-pr-0" />
                        </tr>
                    </thead>
                    <tbody>
                        {context.state.fullIndices.map((index, key) => {
                            const { closeValue, highValue, lowValue, changeValue, changePercentage } = index;

                            return (
                                <tr key={key}>
                                    <td className="column-primary">
                                        <a href={urlEncode(`${window.location.pathname.replace(/\/$/, '')}/${index.instrumentId}`)}>
                                            {index.name}
                                            <span className="text-grey d-xl-none d-block">{index.tickerSymbol}</span>
                                        </a>
                                    </td>
                                    <td className="d-none d-xl-table-cell">{index.tickerSymbol}</td>
                                    <td className="text-right d-none d-xl-table-cell">
                                        {`${truncateNumber(closeValue.amount)}${closeValue.currency == '%' ? '' : ' '}${closeValue.currency}`}
                                    </td>
                                    <td className="text-right d-none d-xl-table-cell">
                                        {`${truncateNumber(highValue.amount)}${highValue.currency == '%' ? '' : ' '}${highValue.currency}`}
                                    </td>
                                    <td className="text-right d-none d-xl-table-cell">
                                        {`${truncateNumber(lowValue.amount)}${lowValue.currency == '%' ? '' : ' '}${lowValue.currency}`}
                                    </td>
                                    <td>
                                        <div className="text-right d-none d-xl-block">
                                            {`${changeValue.amount > 0 ? '+' : ''}${truncateNumber(changeValue.amount)}${changeValue.currency == '%' ? '' : ' '}${changeValue.currency}`}
                                        </div>
                                        <div className='d-xl-none text-right'>
                                            {`${truncateNumber(closeValue.amount)}${closeValue.currency == '%' ? '' : ' '}${closeValue.currency}`}
                                        </div>
                                        <p className="text-plain text-nowrap change-percentage d-xl-none text-right">
                                            {`${truncateNumber(changeValue.amount)}${changeValue.currency == '%' ? '' : ' '}${lowValue.currency}  ${changePercentage.toFixed(2)}%`}
                                        </p>
                                    </td>
                                    <td className="d-none d-xl-table-cell change-percentage">
                                        {`${(changePercentage > 0) ? '+' : ''}${changePercentage.toFixed(2)}%`}
                                    </td>
                                    <td className="indicator fb-pl-0 fb-pr-0" width="32">
                                        <span className={`${(changePercentage > 0 ? 'icon arrow-solid-head-green' : (changePercentage < 0 ? 'icon arrow-solid-head-red arrow-down' : 'icon dash'))}`}>
                                            &nbsp;
                                        </span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            }

            <div className="fb-mt-5 d-xl-none">
                <LastUpdatedIndicator />
            </div>
        </div>
    );
}

export default FullIndices;
